import * as React from 'react';
import { useAuth } from '../../contexts';
import {
  ApplicationViewList,
  type ApplicationViewListProps,
  type TableColumns,
  type FilterFields,
} from '../Application/components/ApplicationViewList';
import { supervisorApplicationListFilter } from '../Nomination/components/filters';

export const SupervisorScholarshipManagementList: React.FunctionComponent =
  () => {
    const { user } = useAuth();

    const visibleFilters: FilterFields[] = React.useMemo(
      () => [
        'entryYear',
        'academicProgramme',
        'programmeType',
        'scholarshipAppliedByApplicant',
        'hkpfsNo',
        'validHKPFS',
        'fundingScheme',
        'fundingSchemeStatus',
        'applicantSurname',
        'applicantGivenName',
        'applicationEmail',
        'applicationNo',
        'applicationStatus',
      ],
      [],
    );
    const listFilter = supervisorApplicationListFilter(user);

    const visibleColumns: TableColumns[] = React.useMemo(
      () => [
        'applicationNo',
        'applicantName',
        'entryYear',
        'applyProgramme',
        'scholarshipApplications',
        'nominatedFundings',
        'applicationStatus',
      ],
      [],
    );
    const filterProps: ApplicationViewListProps['filterProps'] = {
      visibleFilterFields: visibleFilters,
    };
    const tableProps: ApplicationViewListProps['tableProps'] = {
      initialVisibleColumns: visibleColumns,
      listFilter,
    };

    return (
      <ApplicationViewList tableProps={tableProps} filterProps={filterProps} />
    );
  };
